import {contractApi} from "@/axios";
export function salesDataPage(params, data) {
    return contractApi({
        url: '/sales-data/page',
        method: 'post',
        params:params,
        data: data
    })
}
export function downloadSalesInfo(hexCode) {
    return contractApi({
        url: '/sales-data/download/'+hexCode,
        method: 'get',
        responseType: 'blob', // 设置响应类型为 blob
    });
}
export function getClassification(params) {
    return contractApi({
        url: '/documents/get-classification',
        params:params,
        method: 'get',
    });
}